<template>
<svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Female`]" width="1em" height="1em" v-bind="$attrs"><circle cx="8.5" cy="8.5" r="8.5" :fill="useCurrentColor ? 'currentColor' : '#E5557F'"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.6692 6.89999C13.6692 9.05389 11.9231 10.8 9.76921 10.8C9.04497 10.8 8.36684 10.6026 7.7857 10.2586C7.76321 10.2935 7.73675 10.3265 7.70631 10.3571L7.18183 10.8838L8.20631 11.9058C8.44091 12.1399 8.44137 12.5198 8.20733 12.7544C7.9733 12.989 7.5934 12.9894 7.35881 12.7554L6.33516 11.7342L5.02519 13.0499C4.79139 13.2848 4.41149 13.2856 4.17666 13.0518C3.94184 12.818 3.94101 12.4381 4.17481 12.2033L5.48561 10.8867L4.51049 9.91393C4.27589 9.6799 4.27543 9.3 4.50946 9.0654C4.7435 8.8308 5.12339 8.83035 5.35799 9.06438L6.33228 10.0363L6.85593 9.51038C6.85869 9.50761 6.86147 9.50488 6.86426 9.50217C6.24555 8.81193 5.86925 7.8999 5.86925 6.89999C5.86925 4.74609 7.61534 3 9.76921 3C11.9231 3 13.6692 4.74609 13.6692 6.89999ZM12.5336 6.92917C12.5336 8.44794 11.3024 9.67917 9.78355 9.67917C8.26475 9.67917 7.03355 8.44794 7.03355 6.92917C7.03355 5.4104 8.26475 4.17917 9.78355 4.17917C11.3024 4.17917 12.5336 5.4104 12.5336 6.92917Z" :fill="useCurrentColor ? 'currentColor' : '#fff'"/></svg>
</template>
<script>

export default {
  name: 'IconFemale',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
